import { loadStripe } from "@stripe/stripe-js";
import { Button } from "antd";
import { CrownOutlined } from "@ant-design/icons";
import React from "react";
import Api from "../../api";
import { userStore } from "../../stores/UserStore";
import { getUserId } from "../../utils";
import { SectionCard } from "../../Components/SectionCard";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY || "");

const formatDate = (dateLike: string | number) => {
  const d = new Date(dateLike);
  if (isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(d);
};

export const Subscription = () => {
  const { userInfo } = userStore;
  if (!userInfo || userInfo.licenseType !== "license") return null;

  const redirectToStripePortal = async () => {
    const stripe = await stripePromise;
    if (!stripe) throw new Error("Failed to load stripe");
    const session = await Api.post(
      "/api/payments/create-customer-portal-session",
      { user_id: getUserId() }
    );
    window.location.href = session.url;
  };

  const hasRenewal = Boolean(userInfo.current_period_end);
  const actions = hasRenewal ? (
    <Button type="primary" onClick={redirectToStripePortal}>
      Manage Subscription
    </Button>
  ) : (
    <a href="/purchase-subscription">
      <Button type="primary">Purchase Monthly License</Button>
    </a>
  );

  return (
    <SectionCard
      icon={<CrownOutlined />}
      title="Subscription"
      description="Your active Hero Zone license"
      actions={actions}
    >
      <div className="stat-row">
        <div className="stat-block">
          <div className="stat-block-label">Valid Until</div>
          <div className="stat-block-value">
            {formatDate(userInfo.licenseExpiryDate)}
          </div>
        </div>
        {hasRenewal && userInfo.current_period_end && (
          <div className="stat-block">
            <div className="stat-block-label">Renews On</div>
            <div className="stat-block-value">
              {formatDate(userInfo.current_period_end)}
            </div>
          </div>
        )}
      </div>
    </SectionCard>
  );
};
